import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';

// import { Ng2SmartTableModule } from 'ng2-smart-table';
import { UsersRoutingModule } from './users-routing.module';
import { ListUserComponent } from './list-user/list-user.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { TeachersComponent } from './teachers/teachers.component';
import { UserActiveComponent } from './user-active/user-active.component';
import { UserQueryComponent } from './user-query/user-query.component';

@NgModule({
  declarations: [
    ListUserComponent,
    CreateUserComponent,
    TeachersComponent,
    UserActiveComponent,
    UserQueryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SharedModule,
    UsersRoutingModule
  ]
})
export class UsersModule { }
